import {
  Card,
  CardContent,
  Chip,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import { formatDateOnlyDMY } from "helpers";
import { checkSettlementType } from "helpers/settlements";
import { CustomChip, LiquidationAggregation } from "types";

type Props = {
  liquidation: LiquidationAggregation;
  id: string | undefined;
  incomeChip?: CustomChip;
  stayChip?: CustomChip;
  dischargeChip?: CustomChip;
};

export default function LiquidationDetailsCard({
  liquidation,
  incomeChip,
  stayChip,
  dischargeChip,
  id,
}: Props) {
  return (
    <Card
      sx={{
        width: "100%",
      }}
    >
      <CardContent
        sx={{
          "@media print": {
            root: { boxShadow: "none" },
            "> *": { "*": { fontSize: 12 } },
          },
        }}
      >
        {!liquidation.parent_liquidation_id && (
          <Grid item xs={12}>
            <Typography variant="body2">Liquidación Nº {id}</Typography>
          </Grid>
        )}
        <Grid item xs={12}>
          <Typography variant="body2">
            Cliente: {liquidation.liquidation_clients[0].razon_social}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body2">
            Período: {formatDateOnlyDMY(liquidation.date_from.toString())} a{" "}
            {formatDateOnlyDMY(liquidation.date_to.toString())}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body2">
            Almacén: {liquidation.store_description}
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sx={{
            my: 1,
            "@media print": {
              my: 0,
            },
          }}
        >
          <Paper elevation={4}>
            <Grid
              container
              sx={{
                padding: 2,
                gap: 2,
                "@media print": {
                  padding: 0,
                  gap: 0,
                },
              }}
            >
              <Grid item xs={12} display="flex" alignItems="center" gap={1}>
                <Typography variant="body2">
                  Valor de Recepción:{" "}
                  {checkSettlementType(
                    liquidation.liquidation_settlement_types[0],
                  )}
                </Typography>
                {incomeChip && (
                  <Chip
                    color={incomeChip.color}
                    size="small"
                    label={incomeChip.label}
                    icon={incomeChip.icon}
                  />
                )}
              </Grid>
              <Grid item xs={12} display="flex" alignItems="center" gap={1}>
                <Typography variant="body2">
                  Valor estadía por día:{" "}
                  {checkSettlementType(
                    liquidation.liquidation_settlement_types[1],
                  )}
                </Typography>
                {stayChip && (
                  <Chip
                    color={stayChip.color}
                    size="small"
                    label={stayChip.label}
                    icon={stayChip.icon}
                  />
                )}
              </Grid>
              <Grid item xs={12} display="flex" alignItems="center" gap={1}>
                <Typography variant="body2">
                  Valor picking + Despacho:{" "}
                  {checkSettlementType(
                    liquidation.liquidation_settlement_types[2],
                  )}
                </Typography>
                {dischargeChip && (
                  <Chip
                    color={dischargeChip.color}
                    size="small"
                    label={dischargeChip.label}
                    icon={dischargeChip.icon}
                  />
                )}
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </CardContent>
    </Card>
  );
}
